function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Form, DatePicker, Button, Table, Space, Alert, Tag, Modal, Dropdown, Drawer } from "antd";
import Common from "./includes/Common";
import moment from "moment";
import Moment from "react-moment";
import { EyeFill, PencilSquare, PrinterFill, ThreeDotsVertical, ImageFill } from "react-bootstrap-icons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
var RangePicker = DatePicker.RangePicker;
import LaboratorySheet from "./LaboratorySheet";
import LaboForm from "./forms/LaboForm";
import ImResultView from "./ImResultView";
import SetImResult from "./forms/SetImResult";
import SetImFile from "./forms/SetImFile";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var SearchActivity = function SearchActivity(_ref) {
  var _ref$dcode = _ref.dcode,
    dcode = _ref$dcode === void 0 ? null : _ref$dcode;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    queueData = _useState4[0],
    setQueueData = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentQueueItem = _useState8[0],
    setCurrentQueueItem = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentQueueItemElement = _useState0[0],
    setCurrentQueueItemElement = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showEditLabo = _useState10[0],
    setShowEditLabo = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showEditIm = _useState12[0],
    setSHowEditIm = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showLabo = _useState14[0],
    setShowLabo = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    currentItem = _useState16[0],
    setCurrentItem = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showIm = _useState18[0],
    setShowIm = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showCheck = _useState20[0],
    setShowCheck = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showImageInput = _useState22[0],
    setShowImageInput = _useState22[1];
  var ref = useRef();
  var cols = [{
    title: "Date",
    dataIndex: "date",
    key: "data",
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: "ID patient",
    dataIndex: "idnumber",
    key: "idnumber",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: "Nom du patient",
    dataIndex: "name",
    key: "name",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: "Motif",
    dataIndex: "reason",
    key: "reason",
    render: function render(text) {
      return /*#__PURE__*/_jsx("div", {
        children: text
      });
    }
  }, {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: function render(q) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [dcode == "LAB" && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(Button, {
            type: "link",
            icon: /*#__PURE__*/_jsx(EyeFill, {
              size: 20
            }),
            onClick: function onClick() {
              setCurrentQueueItem(q);
              setShowLabo(true);
            },
            size: "small",
            children: /*#__PURE__*/_jsx("b", {
              children: " VOIR"
            })
          })
        }), (dcode == "ECH" || dcode == "SCA" || dcode == "IRM" || dcode == "MAM" || dcode == "RAD") && /*#__PURE__*/_jsx(_Fragment, {
          children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
            return /*#__PURE__*/_jsx(Dropdown, {
              placement: "bottomLeft",
              menu: {
                items: [{
                  key: '12' + e.id,
                  label: /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    onClick: function onClick() {
                      setCurrentQueueItem(q);
                      setCurrentQueueItemElement(e);
                      setCurrentItem(e.business_account_medical_item);
                      setShowIm(true);
                    },
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(EyeFill, {
                        size: 18
                      }), " VOIR"]
                    })
                  })
                }, {
                  key: '22' + e.id,
                  label: /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    onClick: function onClick() {
                      setCurrentQueueItem(q);
                      setCurrentQueueItemElement(e);
                      setCurrentItem(e.business_account_medical_item);
                      setSHowEditIm(true);
                    },
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(PencilSquare, {
                        size: 20
                      }), " EDITER INTERPRETATION"]
                    })
                  })
                }, {
                  key: '23' + e.id,
                  label: /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    onClick: function onClick() {
                      setCurrentQueueItem(q);
                      setCurrentQueueItemElement(e);
                      setCurrentItem(e.business_account_medical_item);
                      setShowImageInput(true);
                    },
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(ImageFill, {
                        size: 18
                      }), " EDITER IMAGE"]
                    })
                  })
                }]
              },
              children: /*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(ThreeDotsVertical, {
                  size: 15
                }), /*#__PURE__*/_jsx(Tag, {
                  color: "#DDA41E",
                  children: e.business_account_medical_item.label
                })]
              })
            });
          })
        })]
      });
    }
  }];
  var onSearchFinish = function onSearchFinish(values) {
    setErrorMessage("");
    axios.get("".concat(Common.baseApiUrl, "getqueuedata/").concat(dcode, "/").concat(moment(values.period[0].$d).format(), "/").concat(moment(values.period[1].$d).format(), "/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setQueueData([]);
        response.data.queuedata.forEach(function (q) {
          setQueueData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: q.id,
              date: q.created_at,
              name: q.customer.firstname + " " + q.customer.lastname,
              idnumber: q.customer.idnumber,
              reason: /*#__PURE__*/_jsx(_Fragment, {
                children: dcode == "LAB" && /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  wrap: true,
                  children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                    return /*#__PURE__*/_jsx(Tag, {
                      style: {
                        cursor: "pointer"
                      },
                      onClick: function onClick() {
                        setCurrentQueueItem(q);
                        setCurrentQueueItemElement(e);
                        setCurrentItem(e.business_account_medical_item);
                        dcode == "LAB" && setShowEditLabo(true);
                      },
                      color: "#CBA95A",
                      children: e.business_account_medical_item.label
                    });
                  })
                })
              }),
              action: q
            }]);
          });
        });
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Form, {
        layout: "horizontal",
        onFinish: onSearchFinish,
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Form.Item, {
            name: "period",
            rules: [{
              required: true,
              message: "Champ obligatoire"
            }],
            children: /*#__PURE__*/_jsx(RangePicker, {})
          }), /*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Button, {
              htmlType: "submit",
              type: "primary",
              children: /*#__PURE__*/_jsx("b", {
                children: "CHERCHER"
              })
            })
          }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: errorMessage
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Table, {
        size: "small",
        dataSource: queueData,
        columns: cols,
        stripped: true,
        loading: isDataLoading
      })]
    }), currentQueueItem && currentQueueItem.customer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["RESULTAT LABORATOIRE DU PATIENT N\xBA ", currentQueueItem.customer.idnumber]
        }),
        destroyOnClose: true,
        footer: null,
        centered: true,
        width: "70%",
        open: showEditLabo,
        onCancel: function onCancel() {
          setShowEditLabo(false);
        },
        children: currentQueueItemElement && currentQueueItemElement.laboratory_result_id != null && /*#__PURE__*/_jsx(LaboForm, {
          business_account_medical_item: currentItem,
          laboratory_result_id: currentQueueItemElement.laboratory_result_id,
          queue_item: currentQueueItem,
          queue_item_element: currentQueueItemElement,
          customer: currentQueueItem.customer,
          handler: function handler() {
            setShowEditLabo(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Opération réussie"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["FICHE DE RESULTAT DU PATIENT N\xBA ", currentQueueItem.customer.idnumber]
        }),
        destroyOnClose: true,
        footer: null,
        centered: true,
        width: "70%",
        open: showLabo,
        onClose: function onClose() {
          setShowLabo(false);
        },
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref2) {
                var handlePrint = _ref2.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  size: "large",
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PrinterFill, {
                      size: 22
                    }), " IMPRIMER"]
                  })
                });
              }
            })
          })
        }),
        children: /*#__PURE__*/_jsx(LaboratorySheet, {
          ref: ref,
          queue_item: currentQueueItem
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "COMPTE RENDU DU SCANNER"
        }),
        destroyOnClose: true,
        width: "95%",
        open: showIm,
        onClose: function onClose() {
          setShowIm(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref3) {
              var handlePrint = _ref3.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: currentQueueItemElement != null && currentQueueItemElement.im_result != null && /*#__PURE__*/_jsx(ImResultView, {
          ref: ref,
          business_account_medical_item: currentQueueItemElement.business_account_medical_item,
          im_result: currentQueueItemElement.im_result,
          customer: currentQueueItem.customer
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "EDITER LE COMPTE RENDU"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showEditIm,
        onCancel: function onCancel() {
          setSHowEditIm(false);
        },
        footer: null,
        children: currentQueueItemElement && /*#__PURE__*/_jsx(SetImResult, {
          im_object: currentQueueItemElement.im_result,
          q_item: currentQueueItem,
          m_item: currentItem,
          handler: function handler() {
            setSHowEditIm(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "SAUVEGARDER LE CLICHET"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showImageInput,
        onCancel: function onCancel() {
          setShowImageInput(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx(SetImFile, {
          im_type: "scanner",
          q_item: currentQueueItem,
          m_item: currentItem,
          handler: function handler() {
            setShowImageInput(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      })]
    })]
  });
};
export default SearchActivity;